const path = {
  PREFERENCES: "/settings/preferences",
  SETTINGS: "/settings",
  CLAIM_COUPON: "/claim_coupon",
  HOME: "/",
  HISTORY: "/history",
  INTERNAL_SERVER_ERROR: "/500",
  NEW: "/new",
  NEW_THREAD: "/search/new",
  PRICING: "/pricing",
  RESEARCH_HUB: "/hub",
  RESEARCH_HUB_LISTS: "/hub/lists",
  RESEARCH_HUB_UPLOADED: "/hub/uploaded",
  RESULTS: "/results",
  SEARCH: "/search",
  SIGN_IN: "/sign-in",
  SIGN_UP: "/sign-up",
  SIGN_UP_ONBOARDING: "/sign-up/onboarding",
  SIGN_UP_SSO_CALLBACK: "/sign-up/sso-callback",
  SUBSCRIPTION: "/settings/subscription",
  TOO_MANY_REQUESTS: "/429",
  ORGANIZATION: "/organization",
};

export default path;
